import { CarouselButtonPadding } from 'omakase/Carousel/Carousel';
import { IconArrowLeft } from '@tock/icons';
import { Theme } from '@emotion/react';
import { arrowBtn, dotBtn } from './carouselCssDefs';
import IconButton from 'omakase/Button/IconButton';

interface CarouselButtonProps {
  disabled: boolean;
  onClick: () => void;
  padding: CarouselButtonPadding;
  showOnMobile: boolean;
  show: boolean;
}

export const PrevButton: React.FunctionComponent<CarouselButtonProps> = ({
  showOnMobile,
  padding,
  show = false,
  ...rest // includes disabled, onClick
}) => (
  <IconButton
    size="small"
    variant="basicBorderless"
    aria-label="Previous Slide"
    css={(theme: Theme) => arrowBtn(theme, { direction: 'left', showOnMobile, padding, show })}
    {...rest}
  >
    <IconArrowLeft fontSize="small" />
  </IconButton>
);

export const NextButton: React.FunctionComponent<CarouselButtonProps> = ({
  showOnMobile,
  padding,
  show = false,
  ...rest
}) => (
  <IconButton
    size="small"
    variant="basic"
    aria-label="Next Slide"
    css={(theme: Theme) => arrowBtn(theme, { direction: 'right', showOnMobile, padding, show })}
    {...rest}
  >
    <IconArrowLeft fontSize="small" />
  </IconButton>
);

export const DotButton = ({
  selected,
  onClick,
  slideNum,
}: {
  selected: boolean;
  onClick: () => void;
  slideNum: number;
}) => (
  <button
    css={dotBtn(selected)}
    type="button"
    onClick={onClick}
    tabIndex={-1}
    aria-label={`Go to slide ${slideNum}`}
  />
);
